import { t } from '@lingui/core/macro';
import { BookingRecordDetailsCustomer } from '@navio/nsdk';
import { getIsTireServiceJob, getIsWindShieldRepairJob } from 'noddi-util';

export const getRelevantInfo = ({
  booking,
  skipCommonInfo = false,
  hasCarryingTires = false
}: {
  booking: BookingRecordDetailsCustomer;
  skipCommonInfo?: boolean;
  hasCarryingTires?: boolean;
}): string[] => {
  const commonInfo = skipCommonInfo ? [] : getCommonRelevantInfo({ isFullyPaid: booking.order.isFullyPaid });
  const isTireServiceJob = getIsTireServiceJob(booking);
  const isWindShieldRepairJob = getIsWindShieldRepairJob(booking);

  // Windshield repair specific info
  if (isWindShieldRepairJob) {
    return [...getWindShieldRelevantInfo(), ...commonInfo];
  }

  // Tire service specific info
  if (isTireServiceJob) {
    return [
      t`Please make sure the car alarm is off. You don't need to be home. Leaving the key out is at your own risk.`,
      ...(hasCarryingTires ? [] : [getTireServiceCarryingTiresInfo()]),
      ...commonInfo
    ];
  }

  // Default info for other services
  return [
    t`You don't have to be home when we arrive. Please ensure the car alarm is deactivated. If you leave the key out, this is at your own risk.`,
    ...commonInfo
  ];
};

// Common info for all bookings
const getCommonRelevantInfo = ({ isFullyPaid }: { isFullyPaid: boolean }) => {
  return [
    t`You will receive a text message when we are on our way, usually 10 to 30 minutes before we expect to arrive.`,
    ...(isFullyPaid
      ? []
      : [t`Payment is made digitally according to the agreement on this page, by credit card or Vipps.`]),
    t`You can make changes to your agreement free of charge until 6:00 PM the day before. After this, a change fee may apply.`
  ];
};

// Carglass texts
const getWindShieldRelevantInfo = () => {
  return [
    t`We need access to unlock the car. Please ensure the car alarm is deactivated. If you leave the key out, this is at your own risk.`,
    getRainingTexts(),
    getTemperedTexts()
  ];
};

export const getRainingTexts = () => t`The car must be under a roof when it's raining`;

export const getTemperedTexts = () =>
  t`The car must be in a tempered environment, (0–29°C) or have a cabin heater available`;

const getTireServiceCarryingTiresInfo = () =>
  t`The tires must be on ground level and less than 10 meters from the car.`;
